<template>
  <b-row>
    <b-col cols="12">
      <compensatory-off-application-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CompensatoryOffApplicationEditForm from './CompensatoryOffApplicationEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    CompensatoryOffApplicationEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
